import styled from "styled-components";

export const ListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (min-width: 1200px) and (max-width: 1477px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    @media (max-width: 570px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;

export const ListItemContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 576px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;
